import { FC } from 'react';
import { FileText, GraduationCap, CheckCircle2 } from 'lucide-react';

interface CreditStatsBarProps {
  transcriptCount: number;
  unofficialTotal: number;
  officialTotal: number;
  creditCap?: number;
}

const StatCard: FC<{
  icon: React.ReactNode;
  label: string;
  value: string;
  hint?: string;
}> = ({ icon, label, value, hint }) => (
  <div className="flex flex-1 flex-col gap-3 rounded-[9px] border border-solid border-(--neutral-black-NB300) bg-(--neutral-white-NW1000) p-5">
    <div className="flex items-center gap-2 text-(--neutral-black-NB700)">
      <span className="text-(--primary-O900)">{icon}</span>
      <span className="[font-size:var(--fs-p4)]!">{label}</span>
    </div>
    <span className="[font-size:var(--fs-h4)]! font-bold leading-tight text-(--neutral-black-NB1000)! m-0!">
      {value}
    </span>
    {hint ? (
      <span className="[font-size:var(--fs-l5)]! text-(--neutral-black-NB600)!">{hint}</span>
    ) : null}
  </div>
);

export const CreditStatsBar: FC<CreditStatsBarProps> = ({
  transcriptCount,
  unofficialTotal,
  officialTotal,
  creditCap = 90,
}) => (
  <div className="flex flex-col gap-4 sm:flex-row">
    <StatCard
      icon={<FileText className="size-5" />}
      label="Transcripts submitted"
      value={String(transcriptCount)}
    />
    <StatCard
      icon={<GraduationCap className="size-5" />}
      label="Unofficial transfer credit estimate"
      value={`${unofficialTotal} / ${creditCap}`}
    />
    <StatCard
      icon={<CheckCircle2 className="size-5" />}
      label="Official credits"
      value={`${officialTotal} / ${creditCap}`}
      hint="Transferred"
    />
  </div>
);
